<template>
  <div id="MRangchaProductList">
    <MHeader />
    <div class="banner">
      <img
        :src="bannerImg"
        alt=""
        srcset=""
      />
    </div>
    <div>
      <van-tabs v-model="activeName" color="#45B035" animated :ellipsis="false">
        <van-tab title="无糖果茶系列" name="a">
          <div style="height: 120vw;">
            <div class="product_box bg_a" style="margin: 9.733vw auto 37.867vw">
              <div class="title">无糖果茶系列</div>
              <div class="dec">
                <div class="dec_item">海拔800米以上</div>
                <div class="dec_item">高山茶园</div>
                <div class="dec_item">0糖0脂0能量</div>
                <div class="dec_item"> 100%真茶萃取</div>
                <div class="dec_item">（*指产品中的茶）</div>
                <div class="dec_item">成分均来自真茶萃取</div>
              </div>
              <!-- 葡萄乌龙茶、柚C茉莉茶、芭乐油柑茉莉、青柠芭乐茉莉 -->
              <div class="box">
                <!-- 葡萄乌龙茶 -->
                <div class="box_item" @click="toRangchaDetail(9)">
                  <div class="img_box">
                    <img
                      src="https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/m500putaowulong.png"
                      alt=""
                      srcset=""
                    />
                  </div>
                  <div class="item_title">
                    <div class="title_left">葡萄乌龙茶</div>
                    <div class="title_right"> 
                    </div>
                  </div>
                </div>

                <!-- 柚C茉莉茶 -->
                <div class="box_item" @click="toRangchaDetail(16)">
                  <div class="img_box">
                    <img
                      src="https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/m500youcmolicha.png"
                      alt=""
                      srcset=""
                    />
                  </div>
                  <div class="item_title">
                    <div class="title_left">柚C茉莉茶</div>
                    <div class="title_right">
                    </div>
                  </div>
                </div>
                <!-- 芭乐油柑茉莉 -->
                <div class="box_item" @click="toRangchaDetail(2)">
                  <div class="img_box">
                    <img
                      src="https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/m500baleyouganmoli.png"
                      alt=""
                      srcset=""
                    />
                  </div>
                  <div class="item_title">
                    <div class="title_left">芭乐油柑茉莉</div>
                    <div class="title_right">
                      <!-- <img
                        src="../../assets/product/tuxing.png"
                        alt=""
                        srcset=""
                      /> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="box_second">
                <!-- 青柠芭乐茉莉 -->
                <div class="box_item" @click="toRangchaDetail(15)">
                  <div class="img_box">
                    <img
                      src="https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/m500qingningbalemoli.png"
                      alt=""
                      srcset=""
                    />
                  </div>
                  <div class="item_title">
                    <div class="title_left">青柠芭乐茉莉</div>
                    <div class="title_right">
                    </div>
                  </div>
                </div> 
                
              </div>
              
            </div>
          </div>
        </van-tab>

        <van-tab title="无糖花果茶系列" name="c">
          <div class="product_box bg_wutanghuaguocha" style="margin: 9.733vw auto 37.867vw">
            <div class="title">无糖花果茶系列</div>
            <div class="dec">
              <div class="dec_item">无糖茶风味升级</div>
              <div class="dec_item">花香+果香+茶香</div>
              <div class="dec_item">0糖0脂0能量</div>
              <div class="dec_item">口感层次丰富</div>
              <div class="dec_item">不单一不寡淡</div>
              <div class="dec_item">海拔800米以上</div>
              <div class="dec_item">高山茶园</div>
              <div class="dec_item">100%真茶萃取</div>
              <div class="dec_item">（*指产品中的茶成分</div>
              <div class="dec_item">均来自真茶萃取）</div>
            </div>
            <div class="box">
              <!-- 茉莉雪梨→玫瑰苹果奇兰 -->
              <div class="box_item" @click="toRangchaDetail(18)">
                <div class="img_box">
                  <img
                    src="https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/m500molixueli.png"
                    alt=""
                    srcset=""
                  />
                </div>
                <div class="item_title">
                  <div class="title_left">茉莉雪梨</div>
                  <div class="title_right"></div>
                </div>
              </div>
              <!-- 玫瑰苹果奇兰 -->
              <div class="box_item" @click="toRangchaDetail(19)">
                <div class="img_box">
                  <img
                    src="https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/m500meiguipingguoqilan.png"
                    alt=""
                    srcset=""
                  />
                </div>
                <div class="item_title">
                  <div class="title_left">玫瑰苹果奇兰</div>
                  <div class="title_right"></div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>

        <van-tab title="高山茶系列" name="d">
          <div class="product_box bg_d" style="margin: 9.733vw auto 37.867vw">
            <div class="title">高山茶系列</div>
            <div class="dec">
              <div class="dec_item">海拔800米以上高山茶园</div>
              <div class="dec_item">0糖0脂0能量</div>
              <div class="dec_item">真茶萃取</div>
              <div class="dec_item">清爽甘甜少苦涩</div>
            </div>
            <div class="box">
              <div class="box_item" @click="toRangchaDetail(12)">
                <div class="img_box">
                  <img
                    src="https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/m500moliwulong.png"
                    alt=""
                    srcset=""
                  />
                </div>
                <div class="item_title">
                  <div class="title_left">茉莉乌龙茶</div>
                  <div class="title_right"></div>
                </div>
              </div>
              <!-- 竹香乌龙茶 -->
              <div class="box_item" @click="toRangchaDetail(13)">
                <div class="img_box">
                  <img
                    src="https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/m500zhuxiangwulong.png"
                    alt=""
                    srcset=""
                  />
                </div>
                <div class="item_title">
                  <div class="title_left">竹香乌龙茶</div>
                  <div class="title_right"></div>
                </div>
              </div> 
              
            </div>
          </div>
        </van-tab>

        <van-tab title="果汁茶系列" name="e">
          <div class="product_box bg_guozhicha" style="margin: 9.733vw auto 37.867vw">
            <div class="title">果汁茶系列</div>
            <div class="dec">
              <div class="dec_item">甜味100%来自果汁/果浆</div>
              <div class="dec_item">配料干净</div>
              <div class="dec_item">添加NFC果汁/果浆</div>
              <div class="dec_item">果汁含量≥50%</div>
              <div class="dec_item">100%真茶萃取%</div>
            </div>
            <div class="box">
              <!-- 姜黄柠檬茶→汁汁莓莓茶 -->
               <!-- 姜黄柠檬茶 -->
              <div class="box_item" @click="toRangchaDetail(20)">
                <div class="img_box">
                  <img
                    src="https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/m310jianghuangningmengcha.png"
                    alt=""
                    srcset=""
                  />
                </div>
                <div class="item_title">
                  <div class="title_left">姜黄柠檬茶</div>
                  <div class="title_right"></div>
                </div>
              </div>
              <!-- 汁汁莓莓茶 -->
              <div class="box_item" @click="toRangchaDetail(21)">
                <div class="img_box">
                  <img
                    src="https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/m310zhizhimeimeicha.png"
                    alt=""
                    srcset=""
                  />
                </div>
                <div class="item_title">
                  <div class="title_left">汁汁莓莓茶</div>
                  <div class="title_right"></div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <MobileConncatUs />
    <MFooter />
  </div>
</template>

<script>
import MHeader from "@/components/MobileHeader";
import MFooter from "@/components/MobileFooter";
import MobileConncatUs from "@/components/MobileConncatUs";
export default {
  name: "RangchaProductList",
  components: {
    MHeader,
    MFooter,
    MobileConncatUs,
  },
  props: {},
  setup() {},
  data() {
    return {
      activeName: "a",
      bannerMap: {
        a: "https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/rangcha_banner_wutangguocha.jpg",
        c: "https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/rangcha_banner_wutanghuaguocha.jpg",
        d: "https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/rangcha_banner_gaoshancha.jpg",
        e: "https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/rangcha_banner_guozhicha.jpg"
      }
    };
  },
  computed: {
    bannerImg() {
      return this.bannerMap[this.activeName] || this.bannerMap['a'];
    }
  },
  watch: {
    "$route.query.type": {
      handler(newVal) {
        if (newVal) {
          this.activeName = newVal;
        }
      },
      immediate: true
    }
  },
  methods: {
    toRangchaDetail(index) {
      this.$router.push(`/mrangcha/detail?pid=${index}`);
    },
  },
  created() {},
  mounted() {},
};
</script>

<style scoped lang="less">
#MRangchaProductList {
  min-height: calc(100vh - 44px - 26.4vw);
  background: #e9e9df;
  margin-top: 18.667vw;
  /* margin-bottom: 37.333vw; */
  .banner {
    width: 100vw;
    height: 46.667vw;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .product_box {
    width: 93.6vw;
    height: 42.667vw;
    position: relative; 
    background-repeat: no-repeat;
    background-size: cover;
    .title {
      width: 8vw;
      height: 32.8vw;
      position: absolute;
      top: -4.933vw;
      left: 3.2vw;
      background: #45B035;
      color: white;
      font-size: 14px;
      font-weight: 500;
      writing-mode: vertical-lr; //垂直方向，从左向右
      text-align: center;
      letter-spacing: 1px;
      line-height: 8vw;
    }
    .dec {
      width: 51.667vw;
      height: 32.333vw;
      position: absolute;
      top: 2.467vw;
      left: 16.133vw;
      /* font-size: 1.467vw; */
      font-size: 8px;
      color: white;
      font-weight: 400;
      .dec_item {
        height: 100%;
        writing-mode: vertical-lr; //垂直方向，从左向右
        letter-spacing: 4px;
        float: left;
        margin-right: 1.333vw;
      }
    }
    .box {
      height: 36.8vw;
      position: absolute;
      top: 32vw;
      left: 7.867vw;
      overflow: hidden;
      .box_item {
        width: 24.267vw;
        height: 36.8vw;
        float: left;
        padding: 0.533vw 0.533vw 0 0.533vw;
        box-sizing: border-box;
        background: white;
        margin-right: 2.4vw;
        .img_box {
          width: 100%;
          height: 30.933vw;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .item_title {
          width: 100%;
          height: 5.333vw;
          background: #fff;
          .title_left {
            float: left;
            font-size: 10px;
            font-weight: 400;
            color: #121212;
            line-height: 5.333vw;
            text-align: center;
            width: 100%;
          }
          .title_right {
            float: right;
            /*  width: 3.2vw; */
            width: 0;
            height: 5.333vw;
            line-height: 1.333vw;
            img {
              width: 3.2vw;
              height: 1.067vw;
            }
          }
        }
      }
    }
  }
  // 用于产品第二行
  .box_second {
      height: 36.8vw;
      position: absolute;
      top: 72vw;
      left: 7.867vw;
      overflow: hidden;
      .box_item {
        width: 24.267vw;
        height: 36.8vw;
        float: left;
        padding: 0.533vw 0.533vw 0 0.533vw;
        box-sizing: border-box;
        background: white;
        margin-right: 2.4vw;
        .img_box {
          width: 100%;
          height: 30.933vw;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .item_title {
          width: 100%;
          height: 5.333vw;
          background: #fff;
          .title_left {
            float: left;
            font-size: 10px;
            font-weight: 400;
            color: #121212;
            line-height: 5.333vw;
            text-align: center;
            width: 100%;
          }
          .title_right {
            float: right;
            /*  width: 3.2vw; */
            width: 0;
            height: 5.333vw;
            line-height: 1.333vw;
            img {
              width: 3.2vw;
              height: 1.067vw;
            }
          }
        }
      }
    }
  
  .bg_a {
    background-image: url("https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/guoweicha.jpg");
  } 
  .bg_wutanghuaguocha {
    background-image: url("https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/wutanghuaguocha.jpg");
  }
  .bg_d {
    background-image: url("https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/gaoshan.png");
  }

  .bg_guozhicha {
    background-image: url("https://rangcha-oss.oss-cn-beijing.aliyuncs.com/v3_website/mobile/product/guozhicha.jpg");
  }
}
</style>
